import * as React from 'react';
import * as _ from 'lodash';
import DropDownControl from '../../../components/PageLayout/Control_DropDown';
import { MaterialsFiltersContainer } from '../../../components/StoneSetup/materialsFilter';
import { PARTS } from './../../../schemas/accessRightsModel';
export default function () {
    function onClick1(AR) {
        AR.e(PARTS.ASSIGN_PP_MANAGE) && this.props.showAssignPricing();
    }
    function scopeAR2() {
        var AR = this.props.AR;
        return React.createElement('div', { 'className': 'app-content-header app-content-header--buttons app-content-header--lined' }, React.createElement('div', { 'className': 'app-content-header--buttons-left' }, AR.e(PARTS.ASSIGN_PP_MANAGE) ? React.createElement('button', {
            'className': 'ui-button4 ui-button4--green',
            'onClick': onClick1.bind(this, AR),
            'key': '503'
        }, React.createElement('span', { 'className': 'ui-button4-icon ui-button-icon--arrow-down' }), React.createElement('span', {}, 'Assign Pricing Profile')) : null), React.createElement('div', { 'className': 'app-content-header--buttons-right' }, React.createElement('div', { 'className': 'buttons-block' }, React.createElement('button', {
            'className': 'ui-button4 ui-button4--blue ui-button4--medium',
            'onClick': this.props.selectAllStones
        }, 'Select All'), React.createElement('button', {
            'className': 'ui-button4 ui-button4--blue ui-button4--medium',
            'onClick': this.props.deselectAllStones
        }, 'Deselect All')), React.createElement('div', { 'className': 'ui-dropdown' }, React.createElement('button', {
            'className': 'ui-button4 ui-button4--blue ui-button4--large ui-button4--dropdown',
            'id': 'btnMaterials'
        }, 'Material Filters'), React.createElement(MaterialsFiltersContainer, {
            'button': 'btnMaterials',
            'hideMarkUpDown': true,
            'expanded': false,
            'type': 'materials',
            'filterName': 'Stone Material'
        })), React.createElement('div', { 'className': 'ui-dropdown' }, React.createElement('button', {
            'className': 'ui-button4 ui-button4--blue ui-button4--large ui-button4--dropdown',
            'id': 'btnColors'
        }, 'Color Filters'), React.createElement(MaterialsFiltersContainer, {
            'button': 'btnColors',
            'expanded': false,
            'type': 'colors',
            'filterName': 'Stone Color'
        }))));
    }
    return scopeAR2.apply(this, []);
}